import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "mdm_bookstore_token";

export function bsGetToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function bsSetToken(token) {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  else localStorage.removeItem(TOKEN_KEY);
}

export function bsClearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

function bsHeaders() {
  const t = bsGetToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export async function bsRegister(payload) {
  const { data } = await axios.post(`${API}/bookstore/register`, payload);
  bsSetToken(data.token);
  return data;
}

export async function bsLogin(email, password) {
  const { data } = await axios.post(`${API}/bookstore/login`, { email, password });
  bsSetToken(data.token);
  return data;
}

export async function bsMe() {
  const { data } = await axios.get(`${API}/bookstore/me`, { headers: bsHeaders() });
  return data.bookstore;
}

export async function bsGet(path) {
  const { data } = await axios.get(`${API}${path}`, { headers: bsHeaders() });
  return data;
}

export async function bsPost(path, body = {}) {
  const { data } = await axios.post(`${API}${path}`, body, { headers: bsHeaders() });
  return data;
}

export function bsFormatError(err) {
  const d = err?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((e) => e?.msg || JSON.stringify(e)).join(" ");
  return err?.message || "Errore di rete.";
}
